import React from "react";
import PropTypes from "prop-types";
import {
  LegacyCard,
  LegacyDataCell,
  LegacyHeaderCell,
  LegacyTable,
  LegacyTableWrapper,
  LegacyTermSheetTableHeader,
  LegacyTermSheetTableRow,
  MemberCellContent,
} from "components/TermSheets";
import { TextLoader } from "components/Loader";
import styled from "@emotion/styled";
import { margins } from "style";
import { TableBody, TableHead, TableRow } from "components/Table";
import { LEGACY_TERMSHEET_COLUMNS_CONFIG } from "constants";
import { CURRENCY_NAMES } from "constants";

/**
 * LoadingRow component that shows loading skeleton for a row
 */
const LegacyLoadingRow = () => (
  <TableRow disableAlternateRowColor>
    {LEGACY_TERMSHEET_COLUMNS_CONFIG.map(({ key, width, sticky, highlightColor }) => (
      <LegacyDataCell key={`loading-${key}`} width={width} marginSize={margins.normal} highlightColor={highlightColor}>
        {sticky ? (
          <MemberCellContent>
            <TextLoader width="12rem" />
          </MemberCellContent>
        ) : (
          <LoaderContainer>
            <TextLoader width="80%" />
          </LoaderContainer>
        )}
      </LegacyDataCell>
    ))}
  </TableRow>
);

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${margins.xsmall};
`;

const LegacyLoadingTable = (props) => (
  <>
    <Loader isExpanded={true} {...props} />
    <Loader isExpanded={false} {...props} />
    <Loader isExpanded={false} {...props} />
  </>
);

const Loader = ({ isExpanded, ...props }) => (
  <LegacyCard {...props}>
    <LegacyTermSheetTableHeader loading={true} isExpanded={isExpanded} {...props} />
    {isExpanded && (
      <LegacyTableWrapper>
        <LegacyTable layout="auto">
          <TableHead>
            <TableRow>
              {LEGACY_TERMSHEET_COLUMNS_CONFIG.map(({ key, width, highlightColor, label }) => (
                <LegacyHeaderCell
                  key={key}
                  scope="col"
                  width={width}
                  marginSize={margins.normal}
                  highlightColor={highlightColor}
                >
                  {typeof label === "function"
                    ? label({ buyInCurrency: CURRENCY_NAMES.cad, sellInCurrency: CURRENCY_NAMES.usd })
                    : label}
                </LegacyHeaderCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <LegacyTermSheetTableRow loading={true} />
            <LegacyTermSheetTableRow loading={true} />
            <LegacyTermSheetTableRow loading={true} />
          </TableBody>
        </LegacyTable>
      </LegacyTableWrapper>
    )}
  </LegacyCard>
);

Loader.propTypes = {
  isExpanded: PropTypes.bool,
};

export { LegacyLoadingRow, LegacyLoadingTable };
